module.exports = __webpack_public_path__ + "static/media/icon-search.c04b5073.svg";